import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NewMexicoMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='new-mexico'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='NM_ZS'
				points='866.04 820.49 472.62 829.85 475.26 855.45 300.34 857.25 298.9 914.14 205.11 916.5 217.54 451.61 855.42 455.95 866.04 820.49'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NM_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NM_ZS')}
			/>
			<polygon
				id='NM_ZN'
				points='855.42 455.95 847 167.03 678.99 172.98 448.95 174.78 225 172.71 217.54 451.61 855.42 455.95'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NM_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NM_ZN')}
			/>
			<rect
				x='555.32'
				y='302.19'
				width='116.72'
				height='22.9'
				fill='none'
				className='shape'
			/>
			<path
				d='M556.53,320.89c1.06.71,2.52,1.24,4.15,1.24,2.19,0,4.21-1.31,4.21-3.66,0-1.45-.82-2.53-2.85-3.64-2.49-1.35-3.88-2.91-3.88-5,0-3.49,3-5.72,6.58-5.72,1.9,0,3.32.55,3.99,1.01l-.85,1.96c-.61-.37-1.83-.93-3.38-.92-2.41,0-3.86,1.59-3.86,3.19,0,1.58.99,2.48,3.03,3.61,2.4,1.29,3.72,2.82,3.72,5.22,0,3.37-2.65,6.02-7.03,6.02-1.95,0-3.87-.64-4.69-1.35l.87-1.96Z'
				className='shape'
			/>
			<path
				d='M581.47,323.9c-.01-.84.13-2.16.31-3.61h-.06c-1.51,2.9-3.44,3.93-5.41,3.93-2.48,0-4.02-1.97-4.02-4.62,0-4.87,3.58-10,9.67-10,1.34,0,2.8.23,3.77.53l-1.43,7.29c-.46,2.43-.66,4.93-.59,6.48h-2.24ZM583.02,311.7c-.34-.11-.85-.2-1.66-.2-3.62,0-6.58,3.77-6.59,7.66-.01,1.56.54,3.09,2.39,3.09,2.01,0,4.36-2.61,5.06-6.33l.81-4.22Z'
				className='shape'
			/>
			<path
				d='M589.66,323.9l1.87-9.91c.31-1.55.5-2.91.66-4.07h2.15l-.36,2.75h.06c1.26-1.97,3.14-3.07,5.19-3.07,1.66,0,3.54.96,3.54,3.88,0,.62-.11,1.51-.25,2.26l-1.55,8.16h-2.39l1.53-8.08c.1-.54.19-1.19.19-1.79,0-1.4-.54-2.44-2.19-2.44s-4.15,2.05-4.78,5.51l-1.26,6.8h-2.39Z'
				className='shape'
			/>
			<path
				d='M613.68,306.16l-.72,3.76h3.34l-.37,1.88h-3.34l-1.29,6.8c-.15.78-.28,1.5-.28,2.23,0,.84.4,1.36,1.32,1.36.43,0,.82-.03,1.13-.11l-.12,1.89c-.43.16-1.16.25-1.85.25-2.11,0-2.94-1.28-2.94-2.71,0-.81.1-1.61.31-2.62l1.36-7.08h-2l.36-1.88h2.01l.59-3.15,2.49-.61Z'
				className='shape'
			/>
			<path
				d='M628.03,323.9c-.01-.84.13-2.16.31-3.61h-.06c-1.51,2.9-3.44,3.93-5.41,3.93-2.48,0-4.02-1.97-4.02-4.62,0-4.87,3.58-10,9.67-10,1.34,0,2.8.23,3.77.53l-1.43,7.29c-.46,2.43-.66,4.93-.59,6.48h-2.24ZM629.58,311.7c-.34-.11-.85-.2-1.66-.2-3.62,0-6.58,3.77-6.59,7.66-.01,1.56.54,3.09,2.39,3.09,2.01,0,4.36-2.61,5.06-6.33l.81-4.22Z'
				className='shape'
			/>
			<path
				d='M647.53,304.41h9.89l-.4,2.05h-7.48l-1.26,6.57h6.89l-.4,2.04h-6.89l-1.67,8.83h-2.4l3.71-19.49Z'
				className='shape'
			/>
			<path
				d='M668.75,323.1c-1.06.59-2.75,1.11-4.62,1.11-3.72,0-5.32-2.53-5.32-5.63,0-4.21,3.13-8.98,7.63-8.98,2.66,0,4.1,1.59,4.11,3.59,0,3.67-4.14,4.64-9.31,4.54-.12.61-.03,1.91.28,2.66.56,1.26,1.67,1.88,3.11,1.88,1.66,0,2.91-.49,3.77-.96l.35,1.79ZM666.1,311.46c-2.28,0-4.01,2.23-4.59,4.42,3.77.04,6.72-.46,6.72-2.64,0-1.15-.88-1.78-2.13-1.78Z'
				className='shape'
			/>
			<polygon
				points='550.65 323.92 550.88 332.91 560.33 332.91 551.01 338.47 551.24 347.46 545.26 341.9 535.94 347.46 541.56 338.47 535.58 332.91 545.03 332.91 550.65 323.92'
				className='shape'
			/>
			<rect
				x='454.21'
				y='401.78'
				width='173.64'
				height='22.9'
				fill='none'
				className='shape'
			/>
			<path
				d='M459.06,417.33l-3.1,6.17h-2.52l10.07-19.49h2.83l2.69,19.49h-2.46l-.79-6.17h-6.73ZM465.61,415.42l-.76-5.63c-.11-1.02-.25-2.44-.34-3.59h-.07c-.52,1.16-1,2.38-1.59,3.55l-2.91,5.67h5.67Z'
				className='shape'
			/>
			<path d='M473.8,423.5l3.92-20.53h2.4l-3.92,20.53h-2.39Z' className='shape' />
			<path
				d='M488.9,402.97l-1.85,9.08.06.02c1.24-1.88,3.04-2.86,4.92-2.86,3.07,0,4.24,2.53,4.24,5.01,0,4.3-3.11,9.61-8.71,9.61-2.46,0-4.31-1.03-4.31-3.61,0-.68.11-1.5.24-2.17l3.01-15.07h2.4ZM485.86,418.09c-.1.48-.19,1.03-.17,1.77.01,1.33.77,2.06,2.26,2.06,3.62,0,5.81-4.3,5.81-7.41,0-1.74-.76-3.33-2.67-3.33-2.07,0-4.22,2.14-4.92,5.42l-.31,1.49Z'
				className='shape'
			/>
			<path
				d='M513.87,409.51l-1.89,9.91c-.3,1.56-.49,2.91-.62,4.07h-2.16l.36-2.64h-.06c-1.25,1.82-3.09,2.96-4.93,2.96s-3.69-.87-3.69-4.05c0-.67.09-1.43.27-2.35l1.51-7.9h2.39l-1.49,7.79c-.15.78-.24,1.45-.24,2.05,0,1.45.59,2.43,2.23,2.43,1.75,0,3.97-2.04,4.56-5.11l1.36-7.17h2.39Z'
				className='shape'
			/>
			<path
				d='M525.25,429.22l1.68-8.28h-.06c-1.16,1.85-3.09,2.87-4.85,2.87-2.78,0-4.16-2.34-4.16-5.08,0-4.68,3.47-9.54,8.91-9.54,1.87,0,3.46.46,4.48.92l-3.6,19.11h-2.4ZM528.6,411.61c-.45-.26-1.27-.49-2.32-.49-3.2,0-5.92,3.42-5.93,7.33-.01,2.15.96,3.4,2.42,3.4,2.27,0,4.38-2.53,4.92-5.41l.91-4.83Z'
				className='shape'
			/>
			<path
				d='M548.89,409.51l-1.89,9.91c-.3,1.56-.49,2.91-.62,4.07h-2.16l.36-2.64h-.06c-1.25,1.82-3.09,2.96-4.93,2.96s-3.69-.87-3.69-4.05c0-.67.09-1.43.27-2.35l1.51-7.9h2.39l-1.49,7.79c-.15.78-.24,1.45-.24,2.05,0,1.45.59,2.43,2.23,2.43,1.75,0,3.97-2.04,4.56-5.11l1.36-7.17h2.39Z'
				className='shape'
			/>
			<path
				d='M562.86,422.7c-1.06.59-2.75,1.11-4.62,1.11-3.72,0-5.32-2.53-5.32-5.63,0-4.21,3.13-8.98,7.63-8.98,2.66,0,4.1,1.59,4.11,3.59,0,3.67-4.14,4.64-9.31,4.54-.12.61-.03,1.91.28,2.66.56,1.26,1.67,1.88,3.11,1.88,1.66,0,2.91-.49,3.77-.96l.35,1.79ZM560.21,411.06c-2.28,0-4.01,2.23-4.59,4.42,3.77.04,6.72-.46,6.72-2.64,0-1.15-.88-1.78-2.13-1.78Z'
				className='shape'
			/>
			<path
				d='M568.19,423.5l1.71-9.01c.34-1.82.56-3.68.71-4.98h2.11c-.11.97-.23,1.95-.39,3.04h.08c.92-1.92,2.41-3.36,4.29-3.36.22,0,.5.02.69.05l-.47,2.37c-.17-.03-.38-.05-.65-.05-2.07,0-3.92,2.52-4.53,5.76l-1.16,6.17h-2.39Z'
				className='shape'
			/>
			<path
				d='M587.02,429.22l1.68-8.28h-.06c-1.16,1.85-3.09,2.87-4.85,2.87-2.78,0-4.16-2.34-4.16-5.08,0-4.68,3.47-9.54,8.91-9.54,1.87,0,3.46.46,4.48.92l-3.6,19.11h-2.4ZM590.37,411.61c-.45-.26-1.27-.49-2.32-.49-3.2,0-5.92,3.42-5.93,7.33-.01,2.15.96,3.4,2.42,3.4,2.27,0,4.38-2.53,4.92-5.41l.91-4.83Z'
				className='shape'
			/>
			<path
				d='M610.66,409.51l-1.89,9.91c-.3,1.56-.49,2.91-.62,4.07h-2.16l.36-2.64h-.06c-1.25,1.82-3.09,2.96-4.93,2.96s-3.69-.87-3.69-4.05c0-.67.09-1.43.27-2.35l1.51-7.9h2.39l-1.49,7.79c-.15.78-.24,1.45-.24,2.05,0,1.45.59,2.43,2.23,2.43,1.75,0,3.97-2.04,4.56-5.11l1.36-7.17h2.39Z'
				className='shape'
			/>
			<path
				d='M624.63,422.7c-1.06.59-2.75,1.11-4.62,1.11-3.72,0-5.32-2.53-5.32-5.63,0-4.21,3.13-8.98,7.63-8.98,2.66,0,4.1,1.59,4.11,3.59,0,3.67-4.14,4.64-9.31,4.54-.12.61-.03,1.91.28,2.66.56,1.26,1.67,1.88,3.11,1.88,1.66,0,2.91-.49,3.77-.96l.35,1.79ZM621.98,411.06c-2.28,0-4.01,2.23-4.59,4.42,3.77.04,6.72-.46,6.72-2.64,0-1.15-.88-1.78-2.13-1.78Z'
				className='shape'
			/>
			<polygon
				points='449.54 423.52 449.76 432.51 459.21 432.51 449.9 438.07 450.12 447.06 444.14 441.5 434.82 447.06 440.44 438.07 434.46 432.51 443.92 432.51 449.54 423.52'
				className='shape'
			/>
			<rect
				x='464.08'
				y='763.96'
				width='144.12'
				height='22.9'
				fill='none'
				className='shape'
			/>
			<path
				d='M468.69,766.18h2.4l-3.32,17.4h7.86l-.4,2.08h-10.24l3.71-19.49Z'
				className='shape'
			/>
			<path
				d='M489.18,785.67c-.01-.84.13-2.16.31-3.61h-.06c-1.51,2.9-3.44,3.93-5.41,3.93-2.48,0-4.02-1.97-4.02-4.62,0-4.87,3.58-10,9.67-10,1.34,0,2.8.23,3.77.53l-1.43,7.29c-.46,2.43-.66,4.93-.59,6.48h-2.24ZM490.74,773.48c-.34-.11-.85-.2-1.66-.2-3.62,0-6.58,3.77-6.59,7.66-.01,1.56.54,3.09,2.39,3.09,2.01,0,4.36-2.61,5.06-6.33l.81-4.22Z'
				className='shape'
			/>
			<path
				d='M497.49,783.24c.66.39,1.86.87,3.01.87,1.61,0,2.66-1.04,2.66-2.28,0-1.09-.49-1.78-1.94-2.58-1.62-.9-2.53-2.13-2.53-3.57,0-2.44,2.12-4.31,5.07-4.31,1.27,0,2.39.34,2.91.69l-.67,1.81c-.48-.28-1.37-.64-2.41-.64-1.46,0-2.49.91-2.49,2.1,0,1.03.67,1.65,1.92,2.35,1.56.88,2.61,2.1,2.61,3.67,0,2.94-2.39,4.61-5.34,4.61-1.5,0-2.84-.47-3.48-.96l.69-1.77Z'
				className='shape'
			/>
			<path
				d='M531.61,785.04c-1.1.49-2.87.93-5.06.93-4.91,0-7.91-3.12-7.91-8.09,0-3.67,1.48-7.17,4.16-9.39,2.02-1.7,4.5-2.61,7.35-2.61,2.17,0,3.72.54,4.22.94l-.77,1.93c-.72-.44-2.1-.8-3.83-.8-2.04,0-4.08.79-5.58,2.18-1.83,1.71-2.99,4.46-2.99,7.42,0,3.48,1.6,6.36,5.93,6.36,1.47,0,3.08-.29,4.16-.83l.32,1.96Z'
				className='shape'
			/>
			<path
				d='M536.39,785.67l1.71-9.01c.34-1.82.56-3.68.71-4.98h2.11c-.11.97-.23,1.95-.39,3.04h.08c.92-1.92,2.41-3.36,4.29-3.36.22,0,.5.02.69.05l-.47,2.37c-.17-.03-.38-.05-.65-.05-2.07,0-3.92,2.52-4.53,5.76l-1.16,6.17h-2.39Z'
				className='shape'
			/>
			<path
				d='M561.51,771.69l-1.89,9.91c-.3,1.56-.49,2.91-.62,4.07h-2.16l.36-2.64h-.06c-1.25,1.82-3.09,2.96-4.93,2.96s-3.69-.87-3.69-4.05c0-.67.09-1.43.27-2.35l1.51-7.9h2.39l-1.49,7.79c-.15.78-.24,1.45-.24,2.05,0,1.45.59,2.43,2.23,2.43,1.75,0,3.97-2.04,4.56-5.11l1.36-7.17h2.39Z'
				className='shape'
			/>
			<path
				d='M575.02,785.12c-.72.35-2.16.86-4.06.86-3.6,0-5.38-2.44-5.38-5.41,0-4.77,3.55-9.19,8.58-9.19,1.3,0,2.48.38,2.91.63l-.69,1.9c-.56-.26-1.32-.53-2.38-.53-3.63,0-5.93,3.58-5.93,6.88,0,2.27,1.19,3.74,3.48,3.74,1.42,0,2.52-.44,3.23-.78l.23,1.89Z'
				className='shape'
			/>
			<path
				d='M589.77,784.87c-1.06.59-2.75,1.11-4.62,1.11-3.72,0-5.32-2.53-5.32-5.63,0-4.21,3.13-8.98,7.63-8.98,2.66,0,4.1,1.59,4.11,3.59,0,3.67-4.14,4.64-9.31,4.54-.12.61-.03,1.91.28,2.66.56,1.26,1.67,1.88,3.11,1.88,1.66,0,2.91-.49,3.77-.96l.35,1.79ZM587.12,773.24c-2.28,0-4.01,2.23-4.59,4.42,3.77.04,6.72-.46,6.72-2.64,0-1.15-.88-1.78-2.13-1.78Z'
				className='shape'
			/>
			<path
				d='M595.21,783.24c.66.39,1.86.87,3.01.87,1.61,0,2.66-1.04,2.66-2.28,0-1.09-.49-1.78-1.94-2.58-1.62-.9-2.53-2.13-2.53-3.57,0-2.44,2.12-4.31,5.07-4.31,1.27,0,2.39.34,2.91.69l-.67,1.81c-.48-.28-1.37-.64-2.41-.64-1.46,0-2.49.91-2.49,2.1,0,1.03.67,1.65,1.92,2.35,1.56.88,2.61,2.1,2.61,3.67,0,2.94-2.39,4.61-5.34,4.61-1.5,0-2.84-.47-3.48-.96l.69-1.77Z'
				className='shape'
			/>
			<polygon
				points='459.41 785.7 459.63 794.69 469.08 794.69 459.77 800.24 459.99 809.23 454.01 803.68 444.7 809.23 450.31 800.24 444.33 794.69 453.79 794.69 459.41 785.7'
				className='shape'
			/>
			<rect
				x='541.03'
				y='601.75'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M540.41,641.28l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M574.9,638.1c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect x='383.42' y='268.8' width='72.08' height='43.33' fill='none' className='shape' />
			<path
				d='M382.81,308.32l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M416.67,311.4l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
		</svg>
	);
};

NewMexicoMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default NewMexicoMap;
